import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter, map, tap } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit {

  loaded = false;
  showLanguageSelection = false;

  constructor(
    private router: Router
  ) { }

  async onLoaded() {
    this.loaded = true;
  }

  ngOnInit(): void {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map(e => (<any>e).url),
      tap(url => this.showLanguageSelection = url === '/tabs/settings')
    ).subscribe();
  }
}
